export const ANALYSIS_TYPES = {
  BANK_STATEMENT_GAP: 'BANK_STATEMENT_GAP',
  GL_BANK_RECONCILIATION: 'GL_BANK_RECONCILIATION',
  CASH_ACTIVITY_REPORT: 'CASH_ACTIVITY_REPORT',
} as const;

export const ANALYSIS_TYPE_LABELS = {
  [ANALYSIS_TYPES.BANK_STATEMENT_GAP]: 'Bank Statement Gap Analysis',
  [ANALYSIS_TYPES.GL_BANK_RECONCILIATION]: 'GL ↔ Bank Reconciliation',
  [ANALYSIS_TYPES.CASH_ACTIVITY_REPORT]: 'Cash Activity Report',
} as const;

export interface Analysis {
  analysis_id: string;
  case_id: string;
  name: string;
  type: typeof ANALYSIS_TYPES[keyof typeof ANALYSIS_TYPES];
  description?: string;
  created_at: string;
  completed_at?: string;
  created_by: string;
  status: 'pending' | 'in_progress' | 'completed' | 'failed';
  results?: any; // Type this based on the specific analysis type
} 